import { Injectable } from '@angular/core';
import { domainServiceEndpoints } from 'configs/domain-service-endpoints';

@Injectable({ providedIn: 'root' })
export class DomainEndpointsService {

  public get advertiserChangesUrl(): string {
    return domainServiceEndpoints.advertiserChangesUrl;
  }

  public get advertiserOffersUrl(): string {
    return domainServiceEndpoints.advertiserOffersUrl;
  }

  public get advertiserPublishersUrl(): string {
    return domainServiceEndpoints.advertiserPublishersUrl;
  }

  public get advertiserPublisherTagsAndPromotionalTypesUrl(): string {
    return domainServiceEndpoints.advertiserPublisherTagsAndPromotionalTypesUrl;
  }

  public get advertiserTimeZoneUrl(): string {
    return domainServiceEndpoints.advertiserTimeZoneUrl;
  }

  public get automationsUrl(): string {
    return domainServiceEndpoints.automationsUrl;
  }

  public get automationUrl(): string {
    return domainServiceEndpoints.automationUrl;
  }

  public get automationPreviewUrl(): string {
    return domainServiceEndpoints.automationPreviewUrl;
  }

  public get automationTestUrl(): string {
    return domainServiceEndpoints.automationTestUrl;
  }

  public get communicationsUrl(): string {
    return domainServiceEndpoints.communicationsUrl;
  }

  public get communicationUrl(): string {
    return domainServiceEndpoints.communicationUrl;
  }

  public get communicationPreviewUrl(): string {
    return domainServiceEndpoints.communicationPreviewUrl;
  }

  public get communicationTestUrl(): string {
    return domainServiceEndpoints.communicationTestUrl;
  }

  public get messagesUrl(): string {
    return domainServiceEndpoints.messagesUrl;
  }

  public get messageUrl(): string {
    return domainServiceEndpoints.messageUrl;
  }

  public get messageViewUrl(): string {
    return domainServiceEndpoints.messageViewUrl;
  }

  public get publisherAdvertisersUrl(): string {
    return domainServiceEndpoints.publisherAdvertisersUrl;
  }

  public get publisherPreferenceUrl(): string {
    return domainServiceEndpoints.publisherPreferencesUrl;
  }

  public get publisherTimeZoneUrl(): string {
    return domainServiceEndpoints.publisherTimeZoneUrl;
  }

  public get templatesUrl(): string {
    return domainServiceEndpoints.templatesUrl;
  }

  public get templateUrl(): string {
    return domainServiceEndpoints.templateUrl;
  }

  public get templatePreviewUrl(): string {
    return domainServiceEndpoints.templatePreviewUrl;
  }

  public get templateTestUrl(): string {
    return domainServiceEndpoints.templateTestUrl;
  }

}
